///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import {
  controls,
  loadingType,
  fscTypes,
  awardRank,
  awardType,
  cellUnit,
  division
} from "./types";
import messages from "./messages";

const boolFormat = value => (value === true ? "Yes" : "No");
const loadingTypeFormat = value => (value ? loadingType[value] : "");
const fscFormat = value =>
  value
    ? fscTypes.find(
        x => (!x.division || x.division === division.coy) && x.value === value
      ).label
    : "";

export const imdlColumns = [
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "shipperLaneId",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.laneId.defaultMessage,
    requiredColumn: true
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "originCity",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.origCity.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "originState",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.origSt.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "originPostalCode",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.origPostal.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "originCountry",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.origCountry.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "destinationCity",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.destCity.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "destinationState",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.destSt.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "destinationPostalCode",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.destPostal.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "destinationCountry",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.destCountry.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "miles",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.miles.defaultMessage,
    rangeFilter: true
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "volume",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.vol.defaultMessage,
    rangeFilter: true
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "bid",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.bid.defaultMessage,
    format: boolFormat
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "hazmat",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.hazmat.defaultMessage,
    format: boolFormat
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "tempRequirement",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.tempReq.defaultMessage,
    format: boolFormat
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "containerSize",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.containerSize.defaultMessage,
    rangeFilter: true
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "originLoadingType",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.origLoadType.defaultMessage,
    format: loadingTypeFormat
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "destinationLoadingType",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.destLoadType.defaultMessage,
    format: loadingTypeFormat
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "containerType",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.contType.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "originDray",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.origDray.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "originDrayAccessorials",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.origDrayAccess.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "originDrayFuel",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.origDrayFuel.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "linehaul",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.linehaul.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "linehaulAccessorials",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.linehaulAccess.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "linehaulFuel",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.linehaulFuel.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "destinationDray",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.destDray.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "destinationDrayAccessorials",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.destDrayAccess.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "destinationDrayFuel",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.destDrayFuel.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "perDiem",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.perDiem.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "baseCost",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.baseCost.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "fuelCost",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.fuelCost.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "totalCost",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.totCost.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "shipperFuelIncome",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.shipFuelIncome.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "margin",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.margin.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "rate",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.rate.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "ratePerMile",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.rpm.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "rampToRampTransit",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.rtrTransit.defaultMessage,
    rangeFilter: true
  },
  {
    control: controls.none,
    right: true,
    filter: false,
    field: "doorToDoorTransit",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.dtdTransit.defaultMessage,
    rangeFilter: true
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "originRamp",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.origRamp.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "destinationRamp",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.destRamp.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "originCarrier",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.origCarrier.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "railCarrier",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.railCarrier.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "destinationCarrier",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.destCarrier.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "quoteType",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.quoteType.defaultMessage
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "fuelSurchargeType",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.fscType.defaultMessage,
    format: fscFormat
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "notes",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.notes.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    field: "awardRate",
    cellUnit: cellUnit.dollar,
    unitLeft: true,
    header: messages.awardRate.defaultMessage
  },
  {
    control: controls.none,
    right: true,
    field: "awardVolume",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.awardVol.defaultMessage,
    rangeFilter: true
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "awardType",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.awardType.defaultMessage,
    format: value =>
      value ? awardType.find(f => f.value === value).label : value
  },
  {
    control: controls.none,
    left: true,
    filter: true,
    field: "awardRank",
    cellUnit: cellUnit.none,
    unitLeft: true,
    header: messages.awardRank.defaultMessage,
    format: value =>
      value ? awardRank.find(f => f.value === value).label : value
  },
  {
    field: "intermodalLaneId",
    header: "",
    control: controls.delete,
    isDraggable: false,
    columnChooserLabel: messages.delete.defaultMessage
  }
];

export default imdlColumns;
